import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl-next';
import { getMessagesForLocale } from '../utils/i18n-get-messages-for-locale';
export var IntlProviderWithResolvedMessages = function IntlProviderWithResolvedMessages(_ref) {
  var children = _ref.children,
    locale = _ref.locale;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    resolvedMessagesForLocale = _useState2[0],
    setResolvedMessagesForLocale = _useState2[1];
  useEffect(function () {
    var fetchMessageLocale = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var messages;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!locale) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return getMessagesForLocale(locale);
            case 3:
              messages = _context.sent;
              setResolvedMessagesForLocale(messages);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchMessageLocale() {
        return _ref2.apply(this, arguments);
      };
    }();
    fetchMessageLocale();
  }, [locale]);
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale || 'en',
    defaultLocale: "en",
    messages: resolvedMessagesForLocale
  }, children);
};